export function toRouter(){

   
};




//////////////////
// WEBPACK FOOTER
// ./static/js/toRouter.js
// module id = 7tHH
// module chunks = 1